import { MaUIWithNavbarLayout } from "@ip-layout";
import { LoadingIcon } from "@ip-widgets/Tailwind/common/misc";

export default function MaUILoadingScreen() {
  return (
    <MaUIWithNavbarLayout>
      <div className="flex justify-center px-4 py-6 space-y-6 bg-white sm:p-6">
        <LoadingIcon />
      </div>
    </MaUIWithNavbarLayout>
  );
}
